'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const LoginModalConfig=require('../../../../dist-es6/client/features/login/modals/loginModalConfig');
const BaseOrganizationProfileController=require('../../../../dist-es6/client/features/organizationProfile/baseOrganizationProfileController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const OrganizationProfileData=require('../../../../dist-es6/client/dtos/organizationProfileData');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');let

OrganizationUsersController=(_class=class OrganizationUsersController extends BaseOrganizationProfileController{
static get $inject(){
return['$scope','$modal','breadcrumbsService','$state','$timeout','userService','socketService','groupsCommandAndQueryService','organizationDefaultsService','uncaughtErrorHandler'];
}

constructor($scope,$modal,breadcrumbsService,$state,$timeout,userService,socketService,groupsCommandAndQueryService,organizationDefaultsService,uncaughtErrorHandler){
super($state,$timeout,userService,socketService,uncaughtErrorHandler);

breadcrumbsService.startTrail('User Access');

this._$scope=$scope;
this._$modal=$modal;

this._groupsCommandAndQueryService=groupsCommandAndQueryService;
this._organizationDefaultsService=organizationDefaultsService;

this.flattenedGroups=null;
this.hideAllGroupsByDefault=null;

this._columnDefinitions=[{
label:'Name',
defaultAscending:!0,
orderBy:['firstName','lastName'],
columnClass:'name-column'},
{
label:'Permissions',
defaultAscending:!0,
isInitiallyActive:!0,
orderBy:['role'],
finalSort:['-isPrimary','firstName','lastName'],
columnClass:'permissions-column'},
{
label:'Group Access',
columnClass:'group-access-column'}];


$scope.$watch('controller.profileData',()=>{
if(!_.exists(this,'profileData')){
return;
}

this.hideAllGroupsByDefault=this.profileData.hideAllGroupsByDefault;

if(_.exists(this,'profileData.users')){
this.profileData.users.forEach(user=>{
user.editUser=()=>this.editUser(user);
user.editUserGroups=()=>this.editUserGroups(user);
});
}

this._tryPopulateGroupVisibilityStringData();
});

this._reloadGroupVisibilityData();
}


async _updateDefaultGroupVisibilitySettings(hideAllGroupsByDefault){
await this._socketService.sendAndWaitForResponse('UpdateDefaultGroupVisibility',hideAllGroupsByDefault);

return await this._reloadProfileData();
}


async _reloadGroupVisibilityData(){
const flattenedGroups=await this._groupsCommandAndQueryService.getFlattenedGroups();

this.flattenedGroups=[{id:null,parentId:null},...flattenedGroups];

this._tryPopulateGroupVisibilityStringData();
}

get columnDefinitions(){return this._columnDefinitions}

createUser(){
let createUserModal=this._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/createUserModalView',
controller:'CreateUserModalController as controller',
windowClass:'create-user',
resolve:{
onUserCreated:()=>this._reloadProfileData.bind(this)}});


createUserModal.result.then(user=>{
this._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/userCreatedModalView',
controller:'UserCreatedModalController as controller',
windowClass:'user-created',
resolve:{
user:()=>user}});


});
}

editUser(user){
let editUserModal=this._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/editOrganizationUserModalView',
controller:'EditOrganizationUserModalController as controller',
windowClass:'edit-user',
resolve:{
user:()=>user,
onUserUpdated:()=>this._reloadProfileData.bind(this)}});


}

editUserGroups(user){
let editUserGroupsModal=this._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/editOrganizationUserGroupsModalView',
controller:'EditOrganizationUserGroupsModalController as controller',
windowClass:'edit-user-groups',
resolve:{
user:()=>user,
orgProfileData:()=>this.profileData,
availableGroups:()=>this.flattenedGroups,
onUserUpdated:()=>this._reloadProfileData.bind(this)}});


}

_tryPopulateGroupVisibilityStringData(){
if(!this.profileData||!this.flattenedGroups){
return;
}

const groupVisibilityStringByUser=new Map;

const{profileData,flattenedGroups}=this;

for(const user of this.profileData.users){
groupVisibilityStringByUser.set(user,_numGroupsVisibleStringFor(user,profileData,flattenedGroups));
}

this._$scope.$evalAsync(()=>{
this.groupVisibilityStringByUser=groupVisibilityStringByUser;
});
}},(_applyDecoratedDescriptor(_class.prototype,'_updateDefaultGroupVisibilitySettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_updateDefaultGroupVisibilitySettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_reloadGroupVisibilityData',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_reloadGroupVisibilityData'),_class.prototype)),_class);



function _numGroupsVisibleStringFor(user,profileData,availableGroups){
if(user.groupVisibilitySettings.visibleGroupIds===null){

if(profileData.hideAllGroupsByDefault){
return'0 Groups (Default)';
}else{
return'All Groups (Default)';
}
}

const initialVisibleGroupIds=new Set(user.groupVisibilitySettings.visibleGroupIds.map(id=>id===null?null:id.toString()));
const filteredToExistingGroups=availableGroups.filter(g=>initialVisibleGroupIds.has(g.id));

const selectedGroupIds=new Set(filteredToExistingGroups.map(g=>g.id));

const subGroupsByParentId=_.groupBy(availableGroups,'parentId');

const subgroupIds=new Set;
for(const selectedGroupId of selectedGroupIds){
const subGroups=_getAllGroupsBelow(selectedGroupId,subGroupsByParentId);
for(const subGroup of subGroups){
if(selectedGroupIds.has(subGroup.id)){
continue;
}
subgroupIds.add(subGroup.id);
}
}

const subgroupSuffix=subgroupIds.size>0?
` (${_pluralize(subgroupIds.size,'Subgroup')})`:
'';

return`${_pluralize(selectedGroupIds.size,'Group')}`+subgroupSuffix;
}

function _getAllGroupsBelow(groupId,subGroupsByParentId){
if(!subGroupsByParentId[groupId]||groupId===null){
return[];
}

const subGroups=subGroupsByParentId[groupId];

return new Set(subGroups.concat(...subGroups.map(group=>_getAllGroupsBelow(group.id,subGroupsByParentId))));
}

function _pluralize(count,label){
return`${count} ${label}${count===1?'':'s'}`;
}

module.exports=OrganizationUsersController;
//# sourceMappingURL=organizationUsersController.js.map
